import { Component } from "@angular/core";

@Component({
	selector: "caass-IDStation",
	templateUrl: "./IDStation.component.html",
})
export class IDStationComponent {}
